<ng-content select="[header]"></ng-content>
<div class="confirmed-membership-template-root">
  <div class="title">
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="image">
    <ng-content select="[image]"></ng-content>
  </div>
  <div class="button-section">
    <ng-content select="[buttonSection]"></ng-content>
  </div>
</div>

